import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { BrowserRouter as Router } from 'react-router-dom'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import createLogger from 'redux-logger'
import Application from './components/Application'

const defaultState = {
  courses: [],
  numberOfCodes: 0,
  contactName: '',
  email: '',
  institution: '',
  ponumber: '',
  payNow: true,
  stripeToken: '',
  book: { id: '-1', title: '________', price: 0 },
  formErrorMsg: '',
  comments: '',
  loading: false,
  finished: false,
}

export const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_COURSES':
      return {
        ...state,
        courses: action.courses,
        book: action.courses[0],
      }
    case 'UPDATE_BOOK':
      return {
        ...state,
        book: action.book,
      }
    case 'UPDATE_NUMBER_OF_CODES':
      return {
        ...state,
        numberOfCodes: action.numberOfCodes,
      }
    case 'UPDATE_CONTACT_NAME':
      return {
        ...state,
        contactName: action.contactName,
      }
    case 'UPDATE_EMAIL':
      return {
        ...state,
        email: action.email,
      }
    case 'UPDATE_INSTITUTION':
      return {
        ...state,
        institution: action.institution,
      }
    case 'UPDATE_PO_NUMBER':
      return {
        ...state,
        ponumber: action.ponumber
      }
    case 'UPDATE_PAYNOW':
      return {
        ...state,
        payNow: action.payNow,
      }
    case 'UPDATE_COMMENTS':
      return {
        ...state,
        comments: action.comments,
      }
    case 'UPDATE_TOKEN':
      return {
        ...state,
        stripeToken: action.stripeToken,
      }
    case 'SET_ERROR_MSG':
      return {
        ...state,
        formErrorMsg: action.formErrorMsg,
      }
    case 'SET_LOADING_STATUS':
      return {
        ...state,
        loading: action.loading,
      }
    case 'SET_FINISH_STATUS':
      return {
        ...state,
        finished: action.finished,
      }
    default:
      return state
  }
}

const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let appStore = compose(middlewares)(createStore)(rootReducer)

export let startOrderAccessCodesApp = stripeKey => {
  ReactDOM.render(
    <Router>
      <Provider store={appStore}>
        <Application stripeKey={stripeKey} />
      </Provider>
    </Router>,
    document.getElementById('order-access-codes-app')
  )
}
